(() => {
  const id = "xencms:views-view--articles";

  Drupal.behaviors[id] = { attach: (context, settings) => {

    once(id, ".views-view--articles", context).forEach((view) => {
      const swiperEl = view.querySelector(".view__rows .swiper");
      if (!(swiperEl instanceof Element)) return;

      const prevEl = view.querySelector(".swiper-button-prev");
      if (!(prevEl instanceof Element)) return;

      const nextEl = view.querySelector(".swiper-button-next");
      if (!(nextEl instanceof Element)) return;

      const paginationEl = view.querySelector(".swiper-pagination");
      if (!(paginationEl instanceof Element)) return;

      const swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 25,
        centerInsufficientSlides: true,
        navigation: {
          nextEl,
          prevEl,
        },
        pagination: {
          el: paginationEl
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        },
      });
    });
  }};
})();
